(function () {
    'use strict';

    angular
        .module('telestatApp')
        .controller('HistoryLoaderLoadingController', HistoryLoaderLoadingController);

    HistoryLoaderLoadingController.$inject = ['entity'];

    function HistoryLoaderLoadingController(entity) {
        var vm = this;
        vm.historyProviderSelector = entity.historyProviderSelector;
    }

})();
